import { Container, ContainerProps } from "@chakra-ui/react"

export default function FullHeightPage({ children, ...props }: ContainerProps) {
  return (
    <Container w="100%" px="0" minH="calc(100vh - 112px)" {...props}>
      {children}
    </Container>
  )
}
